/**
 * Wrappers finos sobre o supabase.auth — concentram o tratamento de erros
 * e padronizam o retorno entre apps.
 */
import type { AuthError } from "@supabase/supabase-js";
import type { PpsSupabaseClient } from "../client";
import type { SignInResult, SignOutScope, SignUpResult } from "../types";

export async function signInWithPassword(
  client: PpsSupabaseClient,
  email: string,
  password: string
): Promise<SignInResult> {
  const { error } = await client.auth.signInWithPassword({ email, password });
  return { error: error ?? null };
}

export async function signUpWithEmail(
  client: PpsSupabaseClient,
  email: string,
  password: string,
  metadata?: { fullName?: string; redirectTo?: string }
): Promise<SignUpResult> {
  const { error } = await client.auth.signUp({
    email,
    password,
    options: {
      emailRedirectTo: metadata?.redirectTo,
      data: metadata?.fullName ? { full_name: metadata.fullName } : undefined,
    },
  });
  return { error: error ?? null };
}

/**
 * Sai SÓ desta sessão (`scope: "local"`) por padrão. O default do supabase-js
 * é `global`, que revoga os refresh tokens do usuário em TODOS os aparelhos —
 * sair no CRM derrubava o celular, e a aba de suporte (impersonação)
 * derrubava o owner. `global` ("sair de todos os dispositivos") só quando o
 * chamador pedir explicitamente.
 */
export async function signOut(
  client: PpsSupabaseClient,
  scope: SignOutScope = "local"
): Promise<AuthError | null> {
  const { error } = await client.auth.signOut({ scope });
  return error ?? null;
}
